import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a71f315"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NewModal" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M13.6583 4.35147C14.1139 4.8201 14.1139 5.5799 13.6583 6.04853L9.81658 10L13.6583 13.9515C14.1139 14.4201 14.1139 15.1799 13.6583 15.6485C13.2027 16.1172 12.464 16.1172 12.0084 15.6485L7.34171 10.8485C6.8861 10.3799 6.8861 9.6201 7.34171 9.15147L12.0084 4.35147C12.464 3.88284 13.2027 3.88284 13.6583 4.35147Z",
    fill: "#64748B"
  })
], -1))
const _hoisted_3 = {
  key: 1,
  class: "header__title"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M11.364 10.586L16.314 5.63599L17.728 7.04999L12.778 12L17.728 16.95L16.314 18.364L11.364 13.414L6.414 18.364L5 16.95L9.95 12L5 7.04999L6.414 5.63599L11.364 10.586Z",
  fill: "#373C49"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "content__body" }
const _hoisted_7 = {
  key: 0,
  class: "content__footer"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "opacity-50 fixed inset-0 z-40",
  style: {"background-color":"#051761"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["NewModal__content", { 'content--overflow': _ctx.overflow, 'max--content': _ctx.maxContent, grey: _ctx.isGrey }]),
      ref: "elementref"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["content__header", { transparentHeader: _ctx.transparentHeader }])
      }, [
        (_ctx.canBack)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "header__back",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitBack && _ctx.emitBack(...args)))
            }, [
              _hoisted_2,
              _createTextVNode(" Назад ")
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.title), 1)),
        (_openBlock(), _createElementBlock("svg", {
          class: "cursor-pointer",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emitCancel && _ctx.emitCancel(...args)))
        }, _hoisted_5))
      ], 2),
      _createElementVNode("div", _hoisted_6, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      (!_ctx.withoutFooter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_ctx.withCancelButton)
              ? (_openBlock(), _createBlock(_component_new_button, {
                  key: 0,
                  class: _normalizeClass(_ctx.cancelButtonClass),
                  onClick: _ctx.emitCancel
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.cancelButtonText), 1)
                  ]),
                  _: 1
                }, 8, ["class", "onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_new_button, {
              class: _normalizeClass(_ctx.confirmButtonClass),
              disabled: _ctx.confirmDisabled,
              onClick: _ctx.emitSubmit,
              loading: _ctx.loading
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.confirmButtonText), 1)
              ]),
              _: 1
            }, 8, ["class", "disabled", "onClick", "loading"])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _hoisted_8
  ]))
}